/**
 * Wrap localStorage and if it's corrupted on Firefox then attempt to clear it.
 * https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
 */

export default {
  setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      if (console) {
        console.warn(
          "localStorage failed setting " +
            key +
            " w/ value: '" +
            value +
            "' with error " +
            e.name,
        );
        console.warn(e);
      }
      if (e.name === "NS_ERROR_FILE_CORRUPTED") {
        window.localStorage.flush();
      }
    }
  },

  getItem(key, missing) {
    let value = missing;
    try {
      value = window.localStorage.getItem(key);
    } catch (e) {
      if (console) {
        console.warn(
          "localStorage failed getting" + key + " with error " + e.name,
        );
        console.warn(e);
      }
      if (e.name === "NS_ERROR_FILE_CORRUPTED") {
        window.localStorage.clear();
      }
    }
    return value;
  },

  removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      if (console) {
        console.warn(
          "localStorage failed removing " + key + " with error " + e.name,
        );
        console.warn(e);
      }
      if (e.name === "NS_ERROR_FILE_CORRUPTED") {
        window.localStorage.clear();
      }
    }
  },

  flush() {
    window.localStorage.clear();
  },
};
